module.exports = __webpack_public_path__ + "images/emoji/clock4.cd4866f6e9079b7d05b3.png";